// extracted by mini-css-extract-plugin
export default {"text":"RefNumTemplate_text__hs8RW","addText":"RefNumTemplate_addText__iaSy6","icon":"RefNumTemplate_icon__FK17N","iconWithValue":"RefNumTemplate_iconWithValue__OijwS"};